import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import { registerServiceWorker } from './registerServiceWorker';

// Suppress untraceable cross-origin script errors or browser extension noise in isolated iframe preview environments
if (typeof window !== 'undefined') {
  const originalOnerror = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' || String(message).toLowerCase().includes('script error')) {
      console.warn('Bypassed global uncaught cross-origin Script error via onerror:', message);
      return true; // Prevent default browser error reporting
    }
    if (originalOnerror) {
      return originalOnerror.apply(this, arguments as any);
    }
    return false;
  };

  window.addEventListener('error', (event) => {
    if (event.message === 'Script error.' || event.message?.toLowerCase().includes('script error')) {
      event.preventDefault();
      console.warn('Safely handled iframe cross-origin Script error:', event);
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && (event.reason.message === 'Script error.' || String(event.reason).toLowerCase().includes('script error'))) {
      event.preventDefault();
      console.warn('Safely handled iframe cross-origin promise rejection error:', event.reason);
    }
  }, true);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Register PWA Service Worker for offline caching and performance optimization
registerServiceWorker();


